// Affiliate/referral program strings for GetPaid. Every org has a stable
// referral link; when a referred org signs up and starts collecting, this
// org earns a share of GetPaid's fee on that org's volume. EN is the source
// of truth — every key here MUST have a native-Portuguese counterpart in
// affiliate.pt-BR.ts.
const affiliate: Record<string, string> = {
  'affiliate.title': 'Affiliate',
  'affiliate.subtitle':
    'Share your referral link. When an organization you refer signs up and starts collecting, you earn a share of the fee GetPaid charges them.',

  'affiliate.loading': 'Loading affiliate summary…',
  'affiliate.error': 'Failed to load affiliate summary.',

  'affiliate.referralLink.label': 'Your referral link',
  'affiliate.referralLink.copy': 'Copy',
  'affiliate.referralLink.copied': 'Copied!',
  'affiliate.referralLink.copiedToast': 'Referral link copied to clipboard.',
  'affiliate.referralLink.copyFailedToast': 'Could not copy the link. Please copy it manually.',

  'affiliate.shareNudge':
    'Anyone who signs up with your link gets 50% off our fee for their first month — and you earn a share of our fee for their first 12 months.',

  'affiliate.stat.currentShare': 'Current share',
  'affiliate.stat.mtdVolume': 'MTD referred volume',
  'affiliate.stat.nextTier': 'Next tier',
  'affiliate.stat.nextTier.value': 'At {volume} → {share}',
  'affiliate.stat.nextTier.topTier': 'You’re at the top tier',
  'affiliate.stat.settledEarnings': 'Settled earnings',
  'affiliate.stat.pendingEarnings': 'Pending earnings',

  'affiliate.payoutNotReady.title': 'Add your Pix payout to receive affiliate earnings',
  'affiliate.payoutNotReady.description':
    "You've earned affiliate fees, but we need a Pix payout destination before we can pay you out.",
  'affiliate.payoutNotReady.cta': 'Add your Pix payout in onboarding to receive affiliate earnings',

  'affiliate.referrals.title': 'Referrals',
  'affiliate.referrals.empty': 'No referrals yet. Share your link to start earning.',
  'affiliate.referrals.column.name': 'Organization',
  'affiliate.referrals.column.createdAt': 'Referred',
  'affiliate.referrals.column.status': 'Status',
  'affiliate.referrals.column.commission': 'Commission',
  'affiliate.referrals.status.pending': 'Pending',
  'affiliate.referrals.status.active': 'Active',
  'affiliate.referrals.status.churned': 'Churned',
  'affiliate.referrals.commission.earningUntil': 'Earning until {date}',
  'affiliate.referrals.commission.ended': 'Commission period ended',
};

export default affiliate;
